import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const PENDING_ESTAMP_REQUESTS = `${LOCAL_URL}/admin/sign/pendingEstampRequest`
export const ESTAMP_PDF_MERGE = `${LOCAL_URL}/admin/sign/estampPDFMerge`
export const LIST_ALL_ESTAMPS = `${LOCAL_URL}/admin/sign/listAllEstampOrders`

const headers = {
  Authorization: API_TOKEN,
}

// function to get pending estamp requests
export async function getAdminPendingEstampRequests() {
  return await axios.get(PENDING_ESTAMP_REQUESTS)
}

// function to upload document for estamp
export async function uploadEstampDoc(document_signing_order_uuid: string, file_data: string) {
  return await axios.post(ESTAMP_PDF_MERGE, {document_signing_order_uuid, file_data})
}

// function to get all estamp requests
export async function getAllEstampRequests(request_status: number) {
  return await axios.post(LIST_ALL_ESTAMPS, {request_status})
}
